import axios from "@/api/axios";

const login = (credentials) => {
  return axios.post("/authentication_token", credentials);
};

const get_user_info = () => {
  return axios.get("/api/user-info");
};

export default {
  login,
  get_user_info,
};
